import { useHistorianStatusQuery } from '@axilon-apps/domains-ontology-ui-state'
import { summarizeHistorianStatus } from './historian-status'

/**
 * Debug-mode footer strip at the bottom of the Tags page: polls the historian
 * diagnostic every 15s and shows write throughput (5-min avg) and database
 * fullness. Render it only when debug mode is active — debug mode is the only
 * toggle.
 */
export function HistorianStatusBar() {
  const { data, error } = useHistorianStatusQuery()
  const summary = data ? summarizeHistorianStatus(data) : null

  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 border-t border-line px-4 py-1.5 text-11 text-ink-3">
      <span>Historian</span>
      {error ? (
        <span className="text-st-down">{error}</span>
      ) : summary ? (
        <>
          <span className="font-mono text-ink">{summary.throughput}</span>
          <span className="font-mono">{summary.fullness}</span>
        </>
      ) : (
        <span>Loading…</span>
      )}
    </div>
  )
}
